import { NotificationsEmptyState } from './NotificationsEmptyState';
import { ProcessedList } from './ProcessedList';
import { useProcessedNotifications } from '~/features/notifications/hooks/useProcessedNotifications';

type Props = {
    onNavigate: () => void;
};

export const ProcessedTab: React.FC<Props> = ({ onNavigate }) => {
    const { data } = useProcessedNotifications();
    const entries = data ?? [];

    if (entries.length === 0) return <NotificationsEmptyState />;

    const sorted = [...entries].sort((a, b) => b.processedAt - a.processedAt);
    return <ProcessedList entries={sorted} onNavigate={onNavigate} />;
};
